import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-foreground-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap cursor-pointer">
              <span className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-fill text-background-50 text-lg"></i>
              </span>
              <span className="text-xl font-bold font-heading text-background-50">
                牛牛影视
              </span>
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed">
              牛牛影视致力于为用户提供免费高清的影视观看体验，覆盖电影大全、电视剧全集、热门综艺和精品动漫，打造一站式免费影视聚合平台。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">
              内容分类
            </h4>
            <ul className="flex flex-col gap-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {cat.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">
              热门推荐
            </h4>
            <ul className="flex flex-col gap-2">
              <li>
                <Link to="/article/movie-001" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                  流浪地球3
                </Link>
              </li>
              <li>
                <Link to="/article/tv-003" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                  三体2：黑暗森林
                </Link>
              </li>
              <li>
                <Link to="/article/movie-004" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                  哪吒之魔童闹海
                </Link>
              </li>
              <li>
                <Link to="/article/tv-001" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                  繁花2
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">
              关于我们
            </h4>
            <ul className="flex flex-col gap-2">
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                  联系我们
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                  用户口碑
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 牛牛影视 - 免费高清影视聚合平台。本站所有内容均来自网络公开资源。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">
              服务条款
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">
              DMCA
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}